import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import PositionSizeCalculator from '../components/PositionSizeCalculator';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function CalculatorPage() {
  const { colors }      = useTheme();
  const { token }       = useAuth();
  const [profile,      setProfile]      = useState(null);
  const [capitalData,  setCapitalData]  = useState(null);
  const [loading,      setLoading]      = useState(true);

  useEffect(() => {
    if (!token) return;
    const headers = { Authorization: `Bearer ${token}` };
    Promise.allSettled([
      axios.get(`${API_URL}/auth/profile`,   { headers }),
      axios.get(`${API_URL}/capital/status`, { headers }),
    ]).then(([profileRes, capitalRes]) => {
      const prof = profileRes.status === 'fulfilled' ? (profileRes.value.data || null) : null;
      setProfile(prof);
      if (capitalRes.status === 'fulfilled') {
        setCapitalData(capitalRes.value.data || null);
      }
    }).finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="pb-6">
      {loading ? (
        <div className="space-y-3 mt-2">
          {[80, 120, 200].map(h => (
            <div key={h} className="rounded-xl animate-pulse"
              style={{ height: h, backgroundColor: colors.inputBg }} />
          ))}
        </div>
      ) : (
        <PositionSizeCalculator profile={profile} capitalData={capitalData} />
      )}
    </div>
  );
}
